export * from 'utils/geoFencing.js';
import * as base from 'utils/geoFencing.js';
import Store from 'store/store';
import getAppRegions from 'utils/bolt/appRegions';

export default async function geoFencing(getGeo, options) {
	const geo = await getGeo();
	const cc = geo.countryCode;

	const [languageCode] = navigator.language.split('-');
	const compoundRegion = `${cc}_${languageCode}`;
	let region = cc;
	const overrides = Store.get().appData?.geofencing?.overrides;
	if (overrides[compoundRegion]) {
		region = compoundRegion;
	} else {
		const apps = await getAppRegions();
		region = apps[compoundRegion] ? compoundRegion : cc;
	}

	return base.default(() => ({ countryCode: region }), options);
}